import { render } from "./Proveedor_Pagos_Tarjeta.vue?vue&type=template&id=54ca2399&scoped=true"
import script from "./Proveedor_Pagos_Tarjeta.vue?vue&type=script&lang=js"
export * from "./Proveedor_Pagos_Tarjeta.vue?vue&type=script&lang=js"

import "./Proveedor_Pagos_Tarjeta.vue?vue&type=style&index=0&id=54ca2399&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ca2399"]])

export default __exports__